import axios from 'axios';
import qs from 'qs';
import {
	GET_APRECOMM_URL,
	LOGIN_APRECOMM_URL,
	API_RESPONSE_SUCCESS_STATUS_CODE,
	GET_APPRECOM_CNMS_TOKEN,
    TENANT_INFO,
    APRECOM_ENDPOINT
} from '../../constants/commonConstants';
import {
	APRECOM_API_LOADING,
	SAVE_APRECOM_DETAILS,
	APRECOM_DETAILS_ERROR
} from '../../constants/graphConstants/connectedClientsGraphConstants';
import { decryptData,encryptData } from '../../utils/crypto';
import { generateRandomAlphanumericString } from '../../utils/utility';
import { getCookie } from '../../utils/cookieHelper';

/**
 * Handles user login functionality for graph onlt.
 *
 * This function takes an username and password as input parameters and dispatches appropriate actions based on the login result.
 * It dispatches a request action when login process starts, sends a POST request to the server with encrypted user credentials,
 *
 * @param {string} username - User's name.
 * @param {string} password - User's password.
 * @return {function} - Asynchronous function that dispatches Redux actions.
 */
export const graphLogin = ({username,tenantName, token}) => async (dispatch, getState) => {
	try {
        // const {
		// 	userLogin: { userInfo },
		// } = getState();
		// await dispatch(getCnmsUserDetals())
		dispatch({type: APRECOM_API_LOADING, payload : true})
		localStorage.setItem('apreTenantName', encryptData(tenantName) || encryptData('canvas'));
			await dispatch(
				getCnmsToken({
					username: username,
					roletype: 1,
					sessionid: generateRandomAlphanumericString(10),
					token:  token,
				})
			);
		} 
	 catch (error) {
		console.log('GRAPH USER_LOGIN_FAIL error = ', error);
		dispatch({type: APRECOM_DETAILS_ERROR, payload : error})
	}
};

/**
 * This function asynchronously dispatches actions to fetch a apcom base url.
 * It sends a request to the server
 * Upon successful response, it will store the URL in local storage.
 * If the authentication token is invalid or expired, it will remove the url from local storage.
 * @param {*} body
 * @return {function} - Asynchronous function
 */
export const getCnmsToken = (body) => async (dispatch, getState) => {
	try {
		// const BASE_URL = 'https://sanity.in01-iocloud.hfcl.com'; // need to replace
        const BASE_URL = `${APRECOM_ENDPOINT}`;
		const url = `${APRECOM_ENDPOINT}/${GET_APPRECOM_CNMS_TOKEN}`;
		// const {
		//     userLogin: { userInfo },
		// } = getState();

		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,
			// headers: {
			// 	'X-Encrypt': 'true',
			// 	'Content-Type': 'application/json',
			// 	Authorization: `${body.token}`,
			// },
			data: JSON.stringify({
				...body,
			}),
		};
		let { data } = await axios.request(config);
			data = decryptData(data);
			data = JSON.parse(data);

		console.log('getCnmsToken:', data);
		if (
			data &&
			data.status &&
			data.status === API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			console.log("inside------")
			await dispatch(getAprecomUrl(data.data.token));
			await dispatch(
				loginToAprecom({
					username: body.username,
					sso: 'hfcl',
					cnmsUrl: BASE_URL,
					sessionid: body.sessionid,
					token: data.data.token,
				})
			);
		}
	} catch (error) {
		localStorage.setItem('aprecom_url', encryptData(String(null)));
		console.log('getAprecomUrl error:', error);
		dispatch({type: APRECOM_DETAILS_ERROR, payload : error})
	}
};

/**
 * This function asynchronously dispatches actions to fetch a apcom base url.
 * It sends a request to the server
 * Upon successful response, it will store the URL in local storage.
 * If the authentication token is invalid or expired, it will remove the url from local storage.
 * @param {*} token
 * @return {function} - Asynchronous function
 */
export const getAprecomUrl = (token) => async (dispatch, getState) => {
	try {
		// const BASE_URL = 'https://sanity.in01-iocloud.hfcl.com/'; // need to replace
		const BASE_URL = `${APRECOM_ENDPOINT}`
		const url = `${BASE_URL}/${GET_APRECOMM_URL}`;
		// const {
		//     userLogin: { userInfo },
		// } = getState();

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			headers: {
				'X-Encrypt': 'true',
				'Content-Type': 'application/json',
				Authorization: `${token}`,
			},
		};

		const { data } = await axios.request(config);
		console.log('getCnmsToken:', data);
		localStorage.setItem('aprecom_url', encryptData(data));
	} catch (error) {
		localStorage.setItem('aprecom_url', encryptData(String(null)));
		console.log('getAprecomUrl error:', error);
		dispatch({type: APRECOM_DETAILS_ERROR, payload : error})
	}
};

/**
 * This function asynchronously dispatches actions to fetch a token from  apcom base url.
 * It sends a request to the server to get the toke with user details like username, sso, cnmsurl
 * Upon successful response, it will store the aprecom token in local storage.
 * If the authentication token is invalid or expired, it will remove the aprecom token from local storage.
 * @param {*} body
 * @return {function} - Asynchronous function
 */
export const loginToAprecom = (body) => async (dispatch, getState) => {
	try {
		// const {
		//     userLogin: { userInfo },
		// } = getState();
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));

		const url = `${APPRECOM_BASE_URL}${LOGIN_APRECOMM_URL}`;
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,
			headers: {
				'X-Encrypt': 'true',
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			data: qs.stringify(body),
		};
		const { data } = await axios.request(config);
		dispatch({type: APRECOM_API_LOADING, payload : false})
		console.log('getCnmsToken:', data);
		if (data && data.success) {
			localStorage.setItem('aprecom_token', encryptData(data.token));
            localStorage.setItem('aprecom_custId', encryptData(String(data.custId)));
			dispatch({type: SAVE_APRECOM_DETAILS, payload : {...data, token: null}})
		} else {
			// localStorage.setItem('aprecom_token', null);
			dispatch({type: APRECOM_DETAILS_ERROR, payload : data})
			console.log('getAprecomToken error --- ', data);
		}
	} catch (error) {
		localStorage.setItem('aprecom_token', encryptData(String(null)));
		console.log('catch getAprecomToken error:', error);
		dispatch({type: APRECOM_DETAILS_ERROR, payload : error})
	}
};


export const getCnmsUserDetals = () => async (dispatch, getState) => {
	try {
		const {
		    userLogin: { userInfo },
		} = getState();

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${APRECOM_ENDPOINT}/${TENANT_INFO}`,
            headers: {
				'X-Encrypt': 'true',
                'Content-Type': 'application/json',
                Authorization: `${userInfo?.authorizationToken ?? ''}`,
            },
		};
		const data = await axios.request(config);
        localStorage.setItem('apreTenantName', encryptData(data?.data) || encryptData('canvas'));
        return data?.data || 'canvas'

	} catch (error) {
		localStorage.setItem('apreTenantName', encryptData(String(null)));
		dispatch({type: APRECOM_DETAILS_ERROR, payload : error})
	}
}

/**
 * It will call the graph api if aprecom token is not there.
 *
 * This function takes an username and password as input parameters and dispatches appropriate actions based on the login result.
 * It dispatches a request action when login process starts, sends a POST request to the server with encrypted user credentials,
 *
 * @param {string} username - User's name.
 * @param {string} password - User's password.
 * @return {function} - Asynchronous function that dispatches Redux actions.
 */
export const checkIfAprecomToken = () => async (dispatch, getState) => {
	try {
		dispatch({type: APRECOM_DETAILS_ERROR, payload : null})
		const {
			userLogin: { userInfo },
			aprecomInfo: { aprecomApiLoading } 
		} = getState();
		const aprecomTokenValue = decryptData(localStorage.getItem('aprecom_token'))
		if((aprecomTokenValue === null || aprecomTokenValue === 'null' || !aprecomTokenValue || aprecomTokenValue === undefined) && !aprecomApiLoading ){

			dispatch(graphLogin({
				username: decryptData(getCookie('userName')),
				tenantName: decryptData(getCookie("tenantName")),
				token: userInfo?.authorizationToken
			}));
			return true;
		}
		return false;
	}
	catch (error) {
		console.log('GRAPH USER_LOGIN_FAIL error = ', error);
		dispatch({type: APRECOM_DETAILS_ERROR, payload : error})
		return false;
	}
};